/** Wrapper for fetching from the WP REST API, primarily our custom extensions. */

import deepmergeCJS from "@fastify/deepmerge";
const deepmerge = deepmergeCJS();

export default async function wpFetch(
	route: string,
	nonce: string,
	customOptions: any = {},
): Promise<any> {
	// Handle options

	const api_version = 1;

	const defaultOptions = {
		namespace: `justask/v${api_version}`,
		credentials: "same-origin",
		headers: {
			"X-WP-Nonce": nonce,
		},
	};

	const mergedOptions = deepmerge(defaultOptions, customOptions);

	const { namespace, ...options } = mergedOptions as RequestInit & {
		namespace: string;
	};

	// Handle fetching

	const response = await fetch(`${window.location.origin}/wp-json/${namespace}/${route}`, options);

	if (!response.ok) {
		throw new Error(`HTTP Error ${response.status}`);
	}

	return await response.json();
}
